<template>
  <InformationItem v-bind="$props">
    <template v-slot:title>E-mail addresses</template>
  </InformationItem>
</template>

<script>
import InformationItem from '@/components/entity/items/InformationItem';

export default {
  components: { InformationItem },
  props: ['items', 'itemType'],
};
</script>
